import { render } from "./SiteNavigation.vue?vue&type=template&id=4d4e0960"
import script from "./SiteNavigation.vue?vue&type=script&lang=js"
export * from "./SiteNavigation.vue?vue&type=script&lang=js"

import "./SiteNavigation.vue?vue&type=style&index=0&id=4d4e0960&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__